import { gql } from '@apollo/client';

export const userForCheckout = gql`
  mutation userForCheckout($userForCheckoutParams: UserForCheckoutParams!) {
    userForCheckout(userForCheckoutParams: $userForCheckoutParams) {
      tokenSet {
        access_token
        expires_in
        id_token
      }
      alterError {
        data
        errorCode
        message
      }
    }
  }
`;
